/**
 * i18n configuration for Path borrower portal.
 *
 * Uses react-i18next with embedded JSON resources (no lazy loading yet).
 * Default language: English. Spanish translations included as proof-of-concept.
 *
 * Usage in components:
 *   import { useTranslation } from 'react-i18next';
 *   const { t } = useTranslation();
 *   <span>{t('common.save')}</span>
 *
 * With namespace:
 *   const { t } = useTranslation('dashboard');
 *   <h1>{t('welcome', { name: borrowerName })}</h1>
 *
 * Gate i18n features behind the 'I18n' feature flag:
 *   <FeatureGate flag="I18n"><LanguageSwitcher /></FeatureGate>
 *
 * See src/i18n/config.ts for the canonical import path.
 * See src/i18n/locales/en.json for the full string catalog.
 * See I18N_PATTERN.md in the docs directory for the developer guide.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: 'en',                // Default language
    fallbackLng: 'en',       // Fallback if translation key missing
    interpolation: {
      escapeValue: false,     // React already escapes output
    },
    react: {
      useSuspense: false,     // Don't suspend while loading translations
    },
  });

export default i18n;
